import { createSlice } from "@reduxjs/toolkit";

const loaderInitialState = {
  loading: false,
  apiCount: 0,
  error: false,
  traceID: "",
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState: loaderInitialState,
  reducers: {
    startLoader: (state, { payload = 1 }) => {
      state.loading = true;
      state.apiCount = payload;
      state.error = false;
      state.traceID = "";
    },

    stopLoader: (state) => {
      state.loading = false;
      state.apiCount = 0;
      state.error = false;
    },

    apiComplete: (state, { payload = 1 }) => {
      state.apiCount -= payload;
      state.loading = state.apiCount > 0;
    },

    apiError: (state, { payload = "" }) => {
      state.loading = false;
      state.error = true;
      state.traceID = payload;
    },
  },
});

export const { startLoader, stopLoader, apiComplete, apiError } =
  loaderSlice.actions;

export default loaderSlice.reducer;
